import React from 'react';
import { FileText, Briefcase } from 'lucide-react';

interface TabsProps {
    activeTab: 'TERMS_CONDITIONS' | 'SERVICE_AGREEMENT';
    onTabChange: (tab: 'TERMS_CONDITIONS' | 'SERVICE_AGREEMENT') => void;
}

export const AceptacionesTabs: React.FC<TabsProps> = ({ activeTab, onTabChange }) => {
    return (
        <div className="px-4 sm:px-7 bg-white border-b border-gray-200 flex overflow-x-auto hide-scrollbar shrink-0">
            <div className="flex space-x-6">
                <button
                    onClick={() => onTabChange('TERMS_CONDITIONS')}
                    className={`flex items-center gap-2 py-3.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                        activeTab === 'TERMS_CONDITIONS'
                            ? 'border-[#4f6df5] text-[#4f6df5]'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                >
                    <FileText size={16} />
                    Términos y Condiciones
                </button>
                <button
                    onClick={() => onTabChange('SERVICE_AGREEMENT')}
                    className={`flex items-center gap-2 py-3.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                        activeTab === 'SERVICE_AGREEMENT'
                            ? 'border-[#4f6df5] text-[#4f6df5]'
                            : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                >
                    <Briefcase size={16} />
                    Contratos de Servicios
                </button>
            </div>
        </div>
    );
};